import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Button, Table, Card, Descriptions, Input } from 'antd';
import styles from './index.less'
import { print } from "@/utils/printUtils";
import moment from 'moment'
import 'braft-editor/dist/index.css'
import 'braft-extensions/dist/table.css'
import BraftEditor from 'braft-editor'
import Common from '../../components/commonTable/commonShowComponent';

const { TextArea } = Input;

const PrintModal = ({
  taskDetail = {},
  infos = {},
  type,
  visible,
  formType = 'default',
  ...other
}) => {

  const controls = []

  const [info, setInfo] = useState({})

  useEffect(() => {
    if (infos) {
      setInfo({ ...infos })
    }
  }, [infos])


  const handlePrint = () => {
    const printContent = document.getElementById("printDetails").parentNode;
    setTimeout(() => {
      print(printContent);
    }, 1500);
  }

  const modalProps = {
    visible: visible,
    // onCancel,
    width: 800,
    okText: '打印',
    ...other
  };

  if (type === 'view') {
    modalProps.footer = null
  }

  const handleChange = (key, value) => {
    let newInfo = { ...info }
    newInfo[key] = value
    setInfo({ ...newInfo })
  }


  return (
    // <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>

    // </Modal>
    <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>
      {formType === 'default'?
      <div id='printDetails'>
        <div className={styles.BSPPrint} id='printDetails'>
          <h2 className={'print-title'} style={{ textAlign: 'center' }}>居家心理训练记录表</h2>
          {(info.overallResultEvaluation||info.documentDate||info.count)&&
          <div>
            <Descriptions bordered>
              <Descriptions.Item span={1} label="整体结果评估">{info.overallResultEvaluation}</Descriptions.Item>
              <Descriptions.Item span={1} label="日期时间">{info.documentDate && moment(info.documentDate).format('YYYY-MM-DD')}</Descriptions.Item>
              <Descriptions.Item span={1} label="次数">第{info.count}次</Descriptions.Item>
            </Descriptions>
          </div>
          }
          <div className={styles.bspCommontContain}>
            <Descriptions bordered column={1}>
              {info.stageGoal&&
              <Descriptions.Item label="阶段目标"><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.stageGoal} autoSize={{ minRows: 1 }} onChange={e => handleChange('stageGoal', e.target.value)} />
              </div></Descriptions.Item>
              }
              {info.thisTimeGoal&&
              <Descriptions.Item label="本次目标"><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.thisTimeGoal} autoSize={{ minRows: 1 }} onChange={e => handleChange('thisTimeGoal', e.target.value)} />
              </div></Descriptions.Item>
              }
              {/* <Descriptions.Item label="完成内容"><div className={styles.html5} style={{ padding: '8px 16px', minHeight: 180 }} dangerouslySetInnerHTML={{ __html: info.completeContent }}></div></Descriptions.Item> */}
              {info.completeContent && <Descriptions.Item label="完成内容">
                <div style={{ padding: '0' }}>
                  <BraftEditor
                    // readOnly={true}
                    controls={controls}
                    // style={{ height: 'auto' }}
                    contentStyle={{ height: 'auto',}}
                    id='editor-1'
                    value={BraftEditor.createEditorState(info.completeContent)}
                  // extendControls={extendControls}
                  />
                </div>
              </Descriptions.Item>}

              {info.specialEvent && <Descriptions.Item label="特别事件"><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.specialEvent} autoSize={{ minRows: 1 }} onChange={e => handleChange('specialEvent', e.target.value)} />
              </div></Descriptions.Item>}
              {info.completion && <Descriptions.Item label="完成情况"><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.completion} autoSize={{ minRows: 1 }} onChange={e => handleChange('completion', e.target.value)} />
              </div></Descriptions.Item>}
              {info.problems && <Descriptions.Item label="问题困扰"><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.problems} autoSize={{ minRows: 1 }} onChange={e => handleChange('problems', e.target.value)} />
              </div></Descriptions.Item>}
              {info.visitorFeedback && <Descriptions.Item label="来访反馈"><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.visitorFeedback} autoSize={{ minRows: 1 }} onChange={e => handleChange('visitorFeedback', e.target.value)} />
              </div></Descriptions.Item>}
              {info.gainGrowth && <Descriptions.Item label="收获成长"><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.gainGrowth} autoSize={{ minRows: 1 }} onChange={e => handleChange('gainGrowth', e.target.value)} />
              </div></Descriptions.Item>}
              {info.reservedHomework && <Descriptions.Item label="预留作业"><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.reservedHomework} autoSize={{ minRows: 1 }} onChange={e => handleChange('reservedHomework', e.target.value)} />
              </div></Descriptions.Item>}
              {info.otherSituationRecord && <Descriptions.Item label="其他情况补充记录">
                {/* <div className={styles.html5} style={{ padding: '8px 16px' }} dangerouslySetInnerHTML={{ __html: info.otherSituationRecord }}></div> */}
                <div style={{ padding: '0' }}>
                  <BraftEditor
                    // readOnly={true}
                    controls={controls}
                    // style={{ height: 'auto' }}
                    contentStyle={{ height: 'auto',}}
                    id='editor-1'
                    value={BraftEditor.createEditorState(info.otherSituationRecord)}
                  // extendControls={extendControls}
                  />
                </div>
              </Descriptions.Item>}
            </Descriptions>
          </div>
          {(info.punchCardVo&&(info.punchCardVo.getUpTime||info.punchCardVo.sleepingTime||info.punchCardVo.sleepQualityScore||info.punchCardVo.dietToday||info.punchCardVo.dietNote||info.punchCardVo.emotionalScoreToday||info.punchCardVo.homeworkToday||info.punchCardVo.homeworkTheme||info.punchCardVo.additionalInformation))&&
          <>
          <h2 className='title' style={{ textAlign: 'center' }}>今日打卡记录</h2>
          <div className={styles.bspCommontContainChild2}>
            <Descriptions bordered>
              {info.punchCardVo.getUpTime&&<Descriptions.Item span={1} label="起床时间" className='descriptionsItem'>{info.punchCardVo && info.punchCardVo.getUpTime && moment(info.punchCardVo.getUpTime).format('HH:mm')}</Descriptions.Item>}
              {info.punchCardVo.sleepingTime&&<Descriptions.Item span={1} label="睡觉时间" className='descriptionsItem'>{info.punchCardVo && info.punchCardVo.sleepingTime && moment(info.punchCardVo.sleepingTime).format('HH:mm')}</Descriptions.Item>}
              {info.punchCardVo.sleepQualityScore&&<Descriptions.Item span={1} label="睡眠质量打分" className='descriptionsItem'>{info.punchCardVo && info.punchCardVo.sleepQualityScore}</Descriptions.Item>}
              {info.punchCardVo.dietToday&&<Descriptions.Item span={1} label="今日饮食情况" className='descriptionsItem'>{info.punchCardVo && info.punchCardVo.dietToday}</Descriptions.Item>}
              {info.punchCardVo.dietNote&&<Descriptions.Item span={1} label="饮食备注" className='descriptionsItem'>{info.punchCardVo && info.punchCardVo.dietNote}</Descriptions.Item>}
              {info.punchCardVo.emotionalScoreToday&&<Descriptions.Item span={1} label="今日情绪打分" className='descriptionsItem'>{info.punchCardVo && info.punchCardVo.emotionalScoreToday}</Descriptions.Item>}
              {info.punchCardVo.homeworkToday&&<Descriptions.Item span={1} label="今日作业是否完成" className='descriptionsItem'>{info.punchCardVo && info.punchCardVo.homeworkToday}</Descriptions.Item>}
              {info.punchCardVo.homeworkTheme&&<Descriptions.Item span={2} label="作业主题" className='descriptionsItem2'>{info.punchCardVo && info.punchCardVo.homeworkTheme}</Descriptions.Item>}
              {info.punchCardVo.additionalInformation&&<Descriptions.Item span={3} label="其他情况补充">{info.punchCardVo && info.punchCardVo.additionalInformation}</Descriptions.Item>}
            </Descriptions>
          </div>
          </>
          }
        </div>
      </div>
      :<Common result={info}/>}
    </Modal>

  );
};

export default Form.create()(PrintModal);
